module.exports = __webpack_public_path__ + "static/media/anetwork-laptop.17cf8062.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/anetwork-laptop.png
// module id = 373
// module chunks = 0